import React, { FC } from 'react';
import useMiniCard from 'hooks/useMiniCard';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import AdvertItemDataModel from 'models/AdvertDataModel/AdvertItemDataModel';
import { YearStyles } from './YearStyles';

interface Props {
  item: AdvertItemDataModel;
  className?: string;
}

const Year: FC<Props> = observer(({ item }) => {
  const {
    appStore: { isDesktop, screenClassNames },
  } = useStores();

  const {
    data: {
      advert: { isPurchase },
    },
  } = useMiniCard();

  if (!isDesktop || !item.year) return null;

  return (
    <YearStyles className={cn(screenClassNames)}>
      {isPurchase && 'от\u00A0'}
      {item.year}&nbsp;г.
    </YearStyles>
  );
});

export default Year;
